export { default } from 'react-media';
export { default as MediaDesktop } from './MediaDesktop';
export { default as MediaMobile } from './MediaMobile';
